import EdtLoop16 from '@carbon/icons-react/es/edt-loop/16';
import styled from 'styled-components';
import { Form } from 'components/atoms/form';

export const StyledEdtLoop16 = styled(EdtLoop16)`
  margin-right: 5px;
`;

export const FormItem = styled(Form.Item)`
  .ant-form-item-label,
  .ant-form-item-label > label {
    width: 100%;
    text-align: left;
    &::after {
      content: '';
    }
  }

  && {
    padding-bottom: 0;
  }
`;
